import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Link from 'next/link'
import { Fragment } from 'react'

export interface PathItem {
  title: string
  href?: string
}

interface Props {
  pathItems: PathItem[]
}

const Breadcrumbs = ({ pathItems }: Props) => {
  return (
    <span className="flex gap-2 items-center">
      {pathItems.map((item, index) => (
        <Fragment key={item.title}>
          {index > 0 && item.title && <FontAwesomeIcon icon={faAngleRight} />}
          {item.href ? (
            <Link href={item.href} className="text-blue">
              {item.title}
            </Link>
          ) : (
            <span>{item.title}</span>
          )}
        </Fragment>
      ))}
    </span>
  )
}

export default Breadcrumbs
